import SplunkRum, { SessionBasedSampler } from '@splunk/otel-web';
const startRumTracing = ({ appName, beaconUrl, rumAuth, sampleRate, enabled, version, env, debug, ...options }) => {
    if (typeof window === 'undefined') {
        console.log('not running in the client');
        return;
    }
    if (!enabled) {
        console.log('Rum tracing is disabled');
        return;
    }
    const { AlwaysOnSampler } = SplunkRum;
    const sampler = sampleRate ? new SessionBasedSampler({ ratio: sampleRate }) : new AlwaysOnSampler();
    SplunkRum.init({
        applicationName: appName,
        beaconEndpoint: beaconUrl,
        rumAccessToken: rumAuth,
        tracer: {
            sampler
        },
        version,
        deploymentEnvironment: env,
        debug,
        ...options
    });
    if (debug) {
        const val = sampler._accumulate(SplunkRum.getSessionId());
        const threshold = sampler._upperBound;
        console.log('val', val);
        console.log('threshold', threshold);
        console.log(`is session sampled: ${val < threshold}`);
    }
};
export { startRumTracing };
//# sourceMappingURL=index.js.map